<template>
    <div id="kassenAdmin">
        <div id="HeaderCont">
            <div id="headerCont">
                <span>Kassensystem Admin</span>
                <span>{{ kassenProjekt.bezeichnung }}</span>
            </div>
        </div>
        <div id="infokartenHeader">Infokarten</div>
        <div id="infoKartenBox2">
        <div id="infoKartenBox">
            <div class="infoCard">
                <div class="infoCardHeader">Umsatz</div>
                <PieChart :dataAPI="this.$props.dataAPI" :kassenProjekt="this.$props.kassenProjekt"/>
            </div>
            <div class="infoCard">
                <div class="infoCardHeader">Anzahl</div>
                <ColumnChart :dataAPI="this.$props.dataAPI" :kassenProjekt="this.$props.kassenProjekt"/>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import ColumnChart from './ColumnChart.vue';
import PieChart from './PieChart.vue';

export default {
  name: "KassensystemAdmin",
  components: {
    PieChart,
    ColumnChart
  },
  props: {
    kassenProjekt: {},
    dataAPI: {}
  },
  data() {
    return {

    };
  },
  methods: {
  },
  async created(){

  }
};
</script>

<style lang="scss">
#kassenAdmin{
    background-color: rgb(238, 239, 243);
    width: 100vw;
    height: 100vh;
    overflow-y: scroll;

    #HeaderCont{
        padding-top: 1rem;
        padding-bottom: 1rem;
        width: 100vw;
        //background-color: rgb(0, 81, 255);
        background-color: #C00000;
        display: flex;
        justify-content: center;
    }

    #headerCont{
        width: 90vw;
        color: white;
        font-size:xx-large;
        display: flex;
        justify-content: space-between;
    }

    #infokartenHeader{
        margin-top: 1rem;
        font-size: xx-large;
        font-weight: bold;
    }

    #infoKartenBox{
        margin-left: 1rem;
        margin-right: 1rem;
        margin-top: 1rem;
        display: flex !important;
        justify-content: center;
        flex-wrap:wrap;
        gap: 1rem;
        //align-content: start;
    }

    #infoKartenBox2{
        display: flex;
        justify-content: center;
    }

    .infoCard{
        padding-top: 1rem;
        //height: 900vh;
        //width: 32rem;
        width: 60vh;
        max-width: 95vw;
        background-color: white;
        box-shadow: 0 0 0 2px rgba(221, 222, 226, 0.486);
        border-radius: 5px;

        .infoCardHeader{
            font-size: xx-large;
        }
    }
}
</style>